var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeBasedGreeting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 87,
    viewBox: "0 0 147 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_84_1744)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M73.5846 87.0001C33.1527 87.0001 0.376205 85.9348 0.376205 84.6207C0.376205 83.3065 33.1527 82.2412 73.5846 82.2412C114.016 82.2412 146.793 83.3065 146.793 84.6207C146.793 85.9348 114.016 87.0001 73.5846 87.0001Z",
    fill: "#EBF4FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M68.1418 85.5012C39.0133 85.5012 15.3999 84.9664 15.3999 84.3068C15.3999 83.6473 39.0133 83.1125 68.1418 83.1125C97.2704 83.1125 120.884 83.6473 120.884 84.3068C120.884 84.9664 97.2704 85.5012 68.1418 85.5012Z",
    fill: "#C5E1F9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M115.68 84.2906H63.3618C63.3618 84.2906 47.4292 68.6811 62.9874 58.4219C80.1787 47.0858 72.995 23.188 98.1917 23.188C125.759 23.188 140.803 72.7626 115.68 84.2919V84.2906Z",
    fill: "#4DAFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M107.878 35.3434C110.064 34.8931 111.602 34.9218 111.602 34.9218C105.488 33.2002 105.554 26.4417 105.554 26.4417L98.2285 34.9218L98.4848 42.5014L104.265 39.9275L107.878 35.3447V35.3434Z",
    fill: "#008CFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M56.5034 72.4805C62.1245 78.7352 80.8332 82.4721 96.2136 79.1477C114.051 75.292 129.314 55.7119 116.237 31.2646C130.794 45.8051 134.455 75.6731 115.679 84.2904H63.3606C63.3606 84.2904 57.9213 78.9597 56.5034 72.4805Z",
    fill: "#008CFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M78.0814 38.4692C80.4379 35.877 83.9335 28.039 84.6092 26.0955C86.1997 26.3931 86.0364 32.6308 85.1283 35.5807C83.9547 39.1153 82.5554 42.4267 81.0831 42.7739C77.168 43.6967 64.9898 42.2335 64.9898 42.2335L59.852 40.7077C59.852 40.7077 74.6243 38.1168 78.0814 38.4692Z",
    fill: "#FFA78C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M84.5186 25.9536C84.5186 25.9536 87.3623 32.2554 85.4174 38.1159C84.7005 37.1566 81.7824 35.8578 79.7631 35.8578C79.7631 35.8578 83.1166 30.4306 84.5199 25.9536H84.5186Z",
    fill: "#B32700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M60.2803 40.393L58.1893 38.1441C57.8056 37.7316 57.2799 37.4758 56.7143 37.4249L54.8145 37.2539C54.3339 37.2108 53.852 37.327 53.4457 37.5828L52.6 38.1167L60.2789 40.393H60.2803Z",
    fill: "#FFA78C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M50.1318 37.3887L48.0501 38.9093C47.7926 39.0973 47.4235 38.9798 47.3279 38.6783L41.1824 19.3189C41.1147 19.1061 41.1864 18.8751 41.3616 18.7354L43.2774 17.2004L50.1305 37.3887H50.1318Z",
    fill: "#00152E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M43.1375 17.6277L49.5379 37.1882C49.6043 37.3892 49.8234 37.5001 50.0291 37.4362C50.2336 37.3709 50.3465 37.1556 50.2814 36.9532L43.881 17.3928C43.8146 17.1918 43.5955 17.0808 43.3898 17.1448C43.1853 17.2101 43.0725 17.4254 43.1375 17.6277Z",
    fill: "#ABB4BE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M50.2207 37.3224L48.2558 38.7581C47.9505 38.9813 48.0314 39.4512 48.3952 39.5622L67.4557 45.3718C67.7358 45.4567 68.0398 45.4305 68.3001 45.2974L70.5557 44.141L50.2193 37.321L50.2207 37.3224Z",
    fill: "#00152E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M70.4373 43.2344L50.7103 37.2211C50.4395 37.1389 50.1514 37.2877 50.0677 37.554C49.9841 37.8202 50.1355 38.1035 50.4063 38.1857L70.1332 44.199C70.4041 44.2812 70.6922 44.1324 70.7758 43.8661C70.8594 43.5999 70.7081 43.3166 70.4373 43.2344Z",
    fill: "#ABB4BE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M50.7662 37.7656C50.7994 37.6599 50.7398 37.549 50.6325 37.5163C50.5252 37.4837 50.4126 37.5424 50.3795 37.6482C50.3464 37.7539 50.406 37.8648 50.5133 37.8975C50.6206 37.9301 50.7331 37.8714 50.7662 37.7656Z",
    fill: "#00152E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M42.3402 83.1721L45.0963 82.3263C45.7375 82.1292 46.2858 81.7141 46.643 81.1542L47.5962 79.6583C48.1232 78.8321 48.491 77.9171 48.6835 76.9604V76.9578C49.6407 73.8265 53.9355 73.3958 55.4038 74.6932C55.5578 75.1944 55.9123 75.6029 56.369 75.8705C57.2054 76.3587 57.4404 77.5347 56.7646 78.2918C56.6359 78.4353 56.4712 78.5437 56.3 78.6337C54.1678 79.7588 52.033 81.333 49.8969 83.1812C49.0658 83.8991 47.9945 84.292 46.8886 84.292H42.5486C42.2937 84.292 42.0494 84.1471 41.9645 83.9108C41.8529 83.5989 42.0295 83.2674 42.3402 83.1721Z",
    fill: "#B4C0C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M68.88 58.809L56.1589 52.6652C57.0245 59.1014 54.2498 68.3478 55.4048 74.6926C53.2262 74.2436 49.5301 75.8725 48.6844 76.9572C48.6844 76.9572 47.6476 58.7268 46.0664 44.8572C45.6694 41.3735 48.9739 38.5947 52.4163 39.5096C59.8018 41.4714 63.1487 42.2376 72.5628 45.9301L80.4355 54.3633L68.88 58.809Z",
    fill: "#333335"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M37.1787 78.8617L36.6596 79.795C36.4113 80.2414 36.4153 80.783 36.6702 81.2268C37.4575 82.5947 36.4525 84.2902 34.8527 84.2902H19.6543C19.0608 84.2902 18.6094 83.7681 18.705 83.1925C18.7661 82.8218 19.0449 82.5229 19.414 82.429L24.6222 81.1054C27.0411 80.4907 29.298 79.3734 31.2403 77.8293C33.4973 77.4508 35.7104 77.563 37.1787 78.8617Z",
    fill: "#B4C0C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M86.3684 49.1603C78.432 46.482 67.231 44.5907 54.9346 42.9617C51.8148 42.5479 48.7918 44.2017 47.5146 47.0315C43.4535 56.0233 37.7647 66.7068 31.2408 77.8301C32.8167 77.8053 35.7348 78.595 37.2735 79.3964C44.2301 70.5899 51.7245 64.3508 54.7621 56.1186L71.7276 60.5878C75.3719 61.5484 79.2591 60.9859 82.4679 59.0345L88.7037 55.2441C90.7947 52.43 89.4073 51.284 86.3698 49.1603H86.3684Z",
    fill: "#333335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M55.2805 52.0326C55.2805 52.0326 61.8469 57.5551 74.2268 56.7315C86.6068 55.9079 84.3592 49.6336 79.7616 47.7423C79.8068 47.5961 79.8572 47.4525 79.905 47.3076C82.2376 47.8819 84.403 48.4967 86.3678 49.1598C89.4054 51.2834 90.7927 52.4294 88.7018 55.2435L82.466 59.034C79.2571 60.9853 75.3699 61.5466 71.7256 60.5872L54.7601 56.118C55.4266 54.3272 55.2792 52.0326 55.2792 52.0326H55.2805Z",
    fill: "#333335"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M88.6984 55.2433C103.667 40.9625 105.552 33.8072 105.297 24.0596C105.199 20.2704 89.6609 19.7536 87.9257 22.5429C83.5778 29.5312 85.4869 41.8371 73.7097 45.9421C92.5883 50.8341 88.6984 55.2419 88.6984 55.2419V55.2433Z",
    fill: "#B32700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M81.0755 48.2193C88.473 49.6342 93.9414 46.3189 82.8996 43.3677C84.3972 40.2351 104.407 29.7892 104.407 29.7892C105.351 27.8509 105.295 24.0618 105.295 24.0618C106.681 33.7154 103.665 40.9647 88.696 55.2454C88.696 55.2454 89.8444 51.2749 81.0755 48.2206V48.2193Z",
    fill: "#B32700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M98.2217 20.9148C97.6535 23.0306 94.4367 25.3396 91.6235 25.6228C87.5105 26.0353 91.0433 21.1289 91.0433 21.1289C91.0433 21.1289 94.3424 20.3235 98.2217 20.9161V20.9148Z",
    fill: "#FFA78C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M89.77 21.4381C86.6886 22.4757 84.822 24.1974 84.4941 26.0365C84.2458 27.4252 85.4221 29.0451 84.4277 32.6319C83.6245 35.5256 86.2731 34.2687 86.2731 34.2687L87.922 27.0559L89.77 21.4368V21.4381Z",
    fill: "#B32700"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M67.2085 37.2897L63.5602 34.4586C63.3704 34.3111 63.1394 34.2237 62.8978 34.2067L59.5628 33.9809C59.4606 33.9744 59.3597 33.9848 59.2614 34.0135L56.3194 34.8606C56.1522 34.9089 56.107 35.1217 56.2411 35.2326C56.4947 35.4401 56.8319 35.5211 57.1545 35.4519L59.1512 35.0277C59.3238 34.9911 59.5017 34.9872 59.6743 35.0172L61.7892 35.3788L59.6478 35.6881C59.3371 35.7325 59.045 35.8565 58.7994 36.0484L58.133 36.5679C57.9604 36.7023 57.975 36.9647 58.1635 37.0795L58.7145 37.4137C59.0464 37.6147 59.4446 37.6826 59.8257 37.6029L61.1891 37.3171C61.302 37.2936 61.4201 37.2949 61.533 37.3223L63.1314 37.7087C63.2721 37.7426 63.4062 37.7974 63.5297 37.8705L65.5795 39.0922L67.2072 37.2884L67.2085 37.2897Z",
    fill: "#FFA78C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M66.3334 36.8426C76.086 37.9873 83.0095 37.426 85.5585 38.4337C86.6817 37.4247 87.7915 36.3622 88.8895 35.2488C89.3183 34.8142 90.0219 34.8116 90.4521 35.2449C91.5752 36.3779 93.098 38.2065 93.9517 40.4555C92.3107 41.484 90.6446 42.4538 88.9479 43.357C87.9495 43.8896 86.7985 44.0697 85.678 43.8831C79.6254 42.8702 70.9721 40.5455 65.5793 39.0941L66.3307 36.8426H66.3334Z",
    fill: "#FFA78C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M88.8715 35.2684C88.8782 35.2619 88.8848 35.2554 88.8914 35.2488C89.3203 34.8142 90.0239 34.8116 90.454 35.2449C91.5772 36.3779 93.1 38.2065 93.9536 40.4555C93.6244 40.6617 93.2672 40.8797 93.2672 40.8797C92.3167 37.7823 88.8729 35.2684 88.8729 35.2684H88.8715Z",
    fill: "#E86060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M88.8675 35.2684C91.1297 32.919 94.1129 29.5723 96.2861 26.8587C97.7014 25.0914 100.082 24.3709 102.256 25.0705C104.248 25.7127 105.248 27.8977 104.415 29.7877C102.973 33.0612 100.655 35.8897 97.7027 37.9625C96.468 38.8304 95.2161 39.6593 93.9482 40.4542C92.76 37.7758 89.9256 35.8754 88.8675 35.2671V35.2684Z",
    fill: "#B32700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M89.0783 35.1959C89.1168 35.1959 89.154 35.1815 89.1832 35.1515C90.852 33.4077 92.7744 31.2749 94.4552 29.3001C94.5056 29.24 94.4976 29.1513 94.4366 29.1017C94.3755 29.0521 94.2852 29.0599 94.2348 29.1199C92.5567 31.0909 90.6396 33.2184 88.9735 34.9596C88.919 35.017 88.9217 35.1058 88.9801 35.1593C89.008 35.1854 89.0425 35.1972 89.0783 35.1972V35.1959Z",
    fill: "#821C00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M98.2285 20.9153C97.2222 20.79 96.1614 13.3057 96.1614 13.3057L91.6967 15.2531C91.6967 15.2531 92.3246 18.8843 91.0501 21.1293C93.3442 22.8914 98.2285 20.9166 98.2285 20.9166V20.9153Z",
    fill: "#FFA78C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M91.6982 15.2511L96.1629 13.3037C96.1629 13.3037 96.4696 15.4613 96.9077 17.4805C96.9077 17.4805 94.8805 19.4841 91.5548 19.86C92.1257 17.7311 91.6982 15.2511 91.6982 15.2511Z",
    fill: "#FFA78C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M85.4588 8.73507C86.031 15.5759 89.2252 19.5856 90.8555 18.8755C93.6156 17.6747 96.4727 15.0172 97.0727 12.2188C97.6728 9.42032 96.5483 4.92766 94.9008 3.52974C93.2532 2.13051 84.88 1.80681 85.4601 8.73507H85.4588Z",
    fill: "#FFA78C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M84.9305 6.3704C85.8465 7.53468 90.0298 4.96073 91.8964 6.16547C94.0126 7.53076 94.2808 10.2626 93.5453 11.8955C92.6399 13.9043 89.2731 15.0137 86.9152 14.9602C86.4731 17.029 87.3905 20.159 88.7858 20.1603C92.2257 20.1603 95.5035 17.3723 96.0638 14.5543C100.315 14.8532 102.3 5.04818 97.88 1.46397C95.1238 -0.770616 89.4656 -0.232853 86.4187 1.66889C84.4406 2.90366 83.8219 4.95812 84.9331 6.3717L84.9305 6.3704Z",
    fill: "#0F0F11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M95.6246 15.2138C94.7525 15.1168 94.1631 14.0157 94.3082 12.7543C94.4532 11.4928 95.2778 10.5488 96.1499 10.6458C97.022 10.7427 97.6114 11.8439 97.4664 13.1053C97.3213 14.3667 96.4968 15.3107 95.6246 15.2138Z",
    fill: "#FFA78C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M96.6994 13.1272C96.7883 12.3571 96.4206 11.6835 95.8789 11.6235C95.8245 11.617 95.7714 11.6196 95.7183 11.6261C95.8484 11.5491 95.9904 11.5139 96.1351 11.5295C96.6171 11.583 96.9437 12.1926 96.8627 12.8896C96.8242 13.2198 96.702 13.5083 96.5334 13.7171C96.6157 13.5422 96.6755 13.3425 96.6994 13.1258V13.1272Z",
    fill: "#E86060"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M107.968 35.3436C102.456 36.0132 92.1095 47.425 88.5515 53.9329C84.9948 60.4409 68.0174 55.7786 63.7265 59.2518C59.4357 62.7251 70.6182 69.9614 70.6182 69.9614L84.6483 70.6414L99.0741 64.4245C99.0741 64.4245 113.402 50.3383 113.104 50.1438C112.807 49.9493 107.966 35.3423 107.966 35.3423L107.968 35.3436Z",
    fill: "#4DAFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M88.3421 54.2761C86.2326 57.9569 90.4424 58.838 90.8394 58.9124C90.3468 58.8236 83.8044 57.658 77.5327 57.7063C82.1674 57.5732 86.5419 57.0002 88.3421 54.2761Z",
    fill: "#008CFF"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_84_1744"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 146.418,
    height: 87,
    fill: "white",
    transform: "matrix(-1 0 0 1 146.805 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeBasedGreeting);
export default __webpack_public_path__ + "static/media/TimeBasedGreeting.4520eb87473e94fe580635c60aa43a13.svg";
export { ForwardRef as ReactComponent };